import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {CSSProperties} from 'react'
import {connect} from 'react-redux'
import Radium, { StyleRoot } from 'radium'
import {Checkbox} from '../Components/Checkbox'

let wrapperStyle: CSSProperties = {
    fontSize: '18px',
    textTransform: 'uppercase',
    maxWidth: '700px',
    alignSelf: 'center',
    margin:'20px auto 10px auto',
    '@media (max-width:414px)': {
        fontSize:'11px',
        width:'95%'
    },
    '@media (max-width:412px)': {
        fontSize:'9px'
    },
    '@media (max-width:375px)': {
        fontSize:'9px',
    },
    '@media (max-width:360px)': {
        fontSize:'7px'
    },
    '@media (max-width:320px)': {
        fontSize:'8px'
    }
}
let subheadStyle: CSSProperties = {
    letterSpacing: '0.3em',
    fontSize: '15px',
    display: 'flex',
    alignSelf: 'center',
    color:'#323232',
    fontFamily:'BarlowMedium'
}
let loginStyle: CSSProperties = {
    letterSpacing: '3px',
    fontSize: '12px',
    display: 'flex',
    alignSelf: 'center',
    cursor: 'pointer'
}
let rowStyle: CSSProperties = {
    padding: '15px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
}
let checkRowStyle = Object.assign({},rowStyle,{position:'relative',marginBottom:'15px'})
let rowWithCheckStyle: CSSProperties = {
    padding: '15px',
    display: 'flex',
    flexDirection: 'row',
}
let labelStyle: CSSProperties = {
    letterSpacing: '1px',
    display: 'flex',
    alignSelf: 'flex-start',
    fontWeight: 100,
    margin: 0,
    color: Tgcc.Styles.darkTextColor,
    lineHeight: '35px',
    fontFamily: 'BarlowMedium',
}
let inputStyle: CSSProperties = {
    display: 'flex',
    flexGrow: 2,
    marginLeft: '6px',
    padding: '0 5px',
    lineHeight: '35px',
    height: '35px',
    border:'2px solid #E9E6E6',
    fontFamily:'BarlowLight',
    '@media (max-width:414px)': {
        lineHeight:'25px'
    }
}
let checkStyle: CSSProperties = {
    display: 'flex',
    marginLeft: '8px',
    padding: '0 5px',
    lineHeight: '35px',
    height: '20px',
    width: '20px',
    alignSelf: 'center',
    border:'2px solid #E9E6E6',
    fontFamily:'AveriaSerifLightItalic',
    '@media (max-width:414px)': {
        lineHeight:'25px',
        height: '15px',
        width: '15px'
    }
}
let fieldBoxStyle: CSSProperties = {
    paddingTop: '15px',
    paddingBottom: '15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
}
let checkCont: CSSProperties = {
    display:'inline-block'
}
let checkCont1 = Object.assign({},checkCont,{marginRight:'100px'});

const rushFee: CSSProperties = {
    position:'absolute',
    top:'60px',
    left:'50%',
    marginLeft:'-100px',
    color:'red',
    fontFamily:'Reitam'
}
const qtyCheck = Object.assign({},rushFee,{marginLeft:'-190px'});

class ProofInfoState {
    proof: Tgcc.Proof;
    user: Tgcc.UserInfo;
    password: string;
    confirmPassword: string;
}

class _RealCampusproofInfo extends React.Component<Tgcc.BaseProps, any>{

    state: ProofInfoState = new ProofInfoState;

    componentWillMount(){
        this.loadState(this.props);
    }

    componentWillReceiveProps(newProps: Tgcc.BaseProps){
        this.loadState(newProps);
        this.state.proof.phone = this.state.user.phone;
        this.state.proof.smsAllowed = this.state.user.smsAllowed;
    }

    loadState = (newProps: Tgcc.BaseProps) => {
        this.setState({
            proof: newProps.state.ActiveProof,
            user: newProps.state.UserInfo
        });
    }

    proofDataChanged = (evt: React.FormEvent<HTMLInputElement>) =>{
        var proof = this.state.proof;
        var name = evt.currentTarget.name;
        if(name == 'smsAllowed' )
            proof[name] = evt.currentTarget.checked;
        else
            proof[name] = evt.currentTarget.value;
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: proof})
    }
    screenPrintChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        var proof = this.state.proof;
        proof.screenPrint = evt.currentTarget.checked        
        if(evt.currentTarget.checked){
            document.getElementById("embroidery")["disabled"] = true;
        } else {
            document.getElementById("embroidery")["disabled"] = false;
        }
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: proof});
    }
    embroideryChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        var proof = this.state.proof;
        proof.embroidery = evt.currentTarget.checked
        if(evt.currentTarget.checked){
            document.getElementById("screenPrint")["disabled"] = true;
        } else {
            document.getElementById("screenPrint")["disabled"] = false;
        }
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: proof});
    }
    formatDate = (date:Date,days:number) => {
        var monthNames = [
            "01", "02", "03",
            "04", "05", "06", "07",
            "08", "09", "10",
            "11", "12"
        ];

        var day = date.getDate() + days;
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        var today = year + '-' + monthNames[monthIndex] + '-' + day;

        return today;
}
    checkDate(){
        var today = this.formatDate(new Date(),5)
        if(this.state.proof){
            if(this.state.proof.inHandsDate &&  new Date(this.state.proof.inHandsDate)  <= new Date(today)   && this.state.proof.inHandsDate.length == 10 && new Date(this.state.proof.inHandsDate) >= new Date(this.formatDate(new Date(),0))){
                return (
                    <div style={rushFee}>A rush fee may apply.</div>
                )
            }
        }
    }
    checkQty(){
        if(this.state.proof.screenPrint && this.state.proof.orderSize < 24){
            return (
                <div style={qtyCheck}>Our minimum for screenprinting is 24.</div>
            )
        }
        if(this.state.proof.embroidery && this.state.proof.orderSize < 24) {
            return (
                <div style={qtyCheck}>Our minimum for embroidery is 24.</div>
            )
        }
        if(!this.state.proof.embroidery && !this.state.proof.screenPrint && this.state.proof.orderSize < 24){
            return (
                <div style={qtyCheck}>Our minimum for screenprinting is 24.</div>
            )
        }
    }

    render(){
        var proof: Tgcc.Proof = this.state.proof;
    
        var loginSuggestion = null, passwordPrompt = null; 
        var loginData = this.props.state.LoginData;
        var userInfo = this.props.state.UserInfo;
     

        return (
            <div style={wrapperStyle} className="campusProofInfo">
                <div style={fieldBoxStyle}>
                    <div style={subheadStyle} className="campusProofTxt">First, tell us about your order</div>
                    <div style={rowStyle}>
                        <label className="labelStyle" style={labelStyle}>Event:</label>
                        <input type='text' style={inputStyle} name='eventName' onChange={this.proofDataChanged} value={proof.eventName||""} placeholder="What are you ordering for?"/>
                    </div>
                    <div style={rowStyle}>
                        <div style={checkCont}><Checkbox fontFamily="BarLowMedium" id="screenPrint" onChange={this.screenPrintChanged} name="cbScreenPrint" label="Screen printing" checked={proof.screenPrint} value={"ScreenPrint"} /></div>
                        <div style={checkCont1} className="corpEmbChk"><Checkbox fontFamily="BarLowMedium" id="embroidery" onChange={this.embroideryChanged} name="cbEmbroidery" label="Embroidery" checked={proof.embroidery} value={"Embroidery"} /></div>
                    </div>
                    <div style={checkRowStyle}>
                        <label className="labelStyle" style={labelStyle}>Estimate Order Quantity:</label>
                        <input type='number' style={inputStyle} name='orderSize' onChange={this.proofDataChanged} value={proof.orderSize||""} placeholder="How many are you thinking?" />                       
                        {this.checkQty()}
                    </div>
                    <div style={checkRowStyle}>
                        <label className="labelStyle" style={labelStyle}>Estimate In Hands Date:</label>
                        <input type='date' style={inputStyle} name='inHandsDate' placeholder="01/02/1990" onChange={this.proofDataChanged} value={proof.inHandsDate || ""}/>
                        {this.checkDate()}
                    </div>
                    <div style={rowStyle}>
                        <label className="labelStyle" style={labelStyle}>Contact Phone:</label>
                        <input type='tel' style={inputStyle} name='phone' onChange={this.proofDataChanged} value={proof.phone}/>
                    </div>
                    <div style={rowWithCheckStyle}>
                        <label className="labelStyle" style={labelStyle}>Receive text notifications:</label>
                        <input type='checkbox' style={checkStyle} name='smsAllowed' onChange={this.proofDataChanged} checked={proof.smsAllowed}/>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return { state: state }
};
export var RealCampusProofInfo = connect(mapStateToProps)(Radium(_RealCampusproofInfo));
